import React from 'react';
import { RoutePermittedRole } from '@projectK/constants/AppEnums';
import Settings from '../../modules/settings';
import Dashboard from '../../modules/coach/Dashboard';
const EditActivity = React.lazy(() =>
  import(
    '../../modules/admin/Products/ServiceSettings/ActivityInfo/EditActivityWizard'
  ),
);
const ActivitySession = React.lazy(() =>
  import(
    '../../modules/admin/Products/ServiceSettings/ActivityInfo/ActivitySessions'
  ),
);
const Reports = React.lazy(() =>
  import('../../modules/coach/ReportManagement'),
);
const UserReports = React.lazy(() =>
  import('../../modules/coach/ReportManagement/UserReports'),
);
const FacilityLocation = React.lazy(() =>
  import('../../modules/coach/ManageFacilities/Location'),
);
const FacilityAddress = React.lazy(() =>
  import('../../modules/coach/ManageFacilities/Address'),
);
const FacilityResource = React.lazy(() =>
  import('../../modules/coach/ManageFacilities/Resource'),
);
const AttendanceList = React.lazy(() =>
  import('../../modules/coach/AttendanceReport'),
);
const ManageActivities = React.lazy(() =>
  import('../../modules/coach/ManageActivities'),
);
const ActivityCalendar = React.lazy(() =>
  import('../../modules/coach/ActivityCalendar'),
);
const ManageSessions = React.lazy(() =>
  import('../../modules/coach/ManageSessions'),
);
const ProductDetail = React.lazy(() =>
  import('../../modules/student/Products/ProductDetail'),
);
const ProductListing = React.lazy(() =>
  import('../../modules/student/Products/ProductListing'),
);
const Cart = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Carts'),
);
const ProductWizardPage = React.lazy(() =>
  import('../../modules/ProductWizardPage'),
);
const PackageWidget = React.lazy(() => import('../../modules/PackageWidget'));

const AddToCart = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks/AddToCart'),
);
const AddToCartProduct = React.lazy(() =>
  import('../../modules/admin/Products/ProductLinks/AddToCartProduct'),
);
const SettingsPage = React.lazy(() =>
  import('../../modules/student/SettingsPage'),
);
const AutoLinks = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks'),
);
const Users = React.lazy(() => import('../../modules/admin/Users'));
const PackageDetail = React.lazy(() =>
  import('../../modules/parent/Packages/PackageDetail'),
);
const Checkout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout'),
);
const OrderConfirmation = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation'),
);

const StripeForm = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation/stripe'),
);
const FailedPayment = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/FailedTranscation'),
);
const TilledCheckout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout-tilled'),
);
const TransactionHistory = React.lazy(() =>
  import('../../modules/student/TransactionHistory'),
);
const CommunicationTab = React.lazy(() =>
  import('../../../../admin/src/modules/admin/Communication'),
);
const UnSubscribePage = React.lazy(() =>
  import('../../modules/account/MyProfile/UnSubscribe'),
);
const AllWaitlist = React.lazy(() =>
  import('../../modules/coach/WaitlistUsers'),
);

const Teams = React.lazy(() => import('../../modules/admin/Teams'));
const Error403 = React.lazy(() => import('../../modules/errorPages/Error403'));
const TeamsEdit = React.lazy(() => import('../../modules/admin/Teams/Edit'));

const ActiveTournaments = React.lazy(() =>
  import('../../modules/admin/Tournament/TournamentsListView'),
);
const coachPages = [
  {
    path: '/coach/edit-activity/:productId/:activityId',
    element: <EditActivity />,
  },
  {
    path: '/coach/edit-session/:productId/:sessionId',
    element: <ActivitySession />,
  },
  {
    path: '/coach/reports',
    element: <Reports />,
  },
  {
    path: '/coach/user-reports',
    element: <UserReports />,
  },
  {
    path: '/coach/address',
    element: <FacilityAddress />,
  },
  {
    path: '/coach/location',
    element: <FacilityLocation />,
  },
  {
    path: '/coach/resource',
    element: <FacilityResource />,
  },
  {
    path: '/coach/attendance',
    element: <AttendanceList />,
  },
  {
    path: '/coach/activities',
    element: <ManageActivities />,
  },
  {
    path: '/coach/calendar',
    element: <ActivityCalendar />,
  },
  {
    path: '/coach/activity-session',
    element: <ManageSessions />,
  },
  {
    path: '/coach/users',
    element: <Users />,
  }, 
  {
    permittedRole: RoutePermittedRole.Coach,
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '/coach/settings',
    element: <SettingsPage />,
  },
  {
    path: '/coach/edit-activity/:productId/:activityId',
    element: <EditActivity />,
  },
  {
    path: '/coach/edit-session/:productId/:sessionId',
    element: <ActivitySession />,
  },
  {
    path: '/product-details/:productId',
    element: <ProductDetail />,
  },
  {
    path: '/coach/product-listing',
    element: <ProductListing />,
  },
  {
    path: '/widgets/products/:productSlug',
    element: <ProductWizardPage />,
  },
  {
    path: '/widgets/packages/:packageSlug',
    element: <PackageWidget />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/purchasePackage/:purchaseId/:packageId',
    element: <AutoLinks />,
  },
  {
    path: '/purchasePackage/addtocart/:purchaseId/:packageId',
    element: <AddToCart />,
  },
  {
    path: '/product/addtocart/:purchaseId/:productId',
    element: <AddToCartProduct />,
  },
  {
    path: '/package-details/:packageId',
    element: <PackageDetail />,
  },
  {
    path: '/checkout-tilled',
    element: <TilledCheckout />,
  },
  {
    path: '/order/confirmation/:transId',
    element: <OrderConfirmation />,
  },
  {
    path: '/stripe',
    element: <StripeForm />,
  },
  {
    path: '/order/failed/:transId',
    element: <FailedPayment />,
  },
  {
    path: '/checkout',
    element: <Checkout />,
  },
  {
    path: '/transaction-history',
    element: <TransactionHistory />,
  },
  {
    path: '/coach/communication',
    element: <CommunicationTab />,
  },
  {
    path: '/user/unsubscribe',
    element: <UnSubscribePage />,
  },
  {
    path: '/coach/my-waitlist',
    element: <AllWaitlist />,
  },
  {
    path: '/coach/teams',
    element: <Teams />,
    requiresTournamentAddon: true, // Add this flag
    permissionKey: 'Tournaments - Tournaments teams',
  },
  {
    path: '/coach/error-pages/error-403',
    element: <Error403 />,
  },  
  {
    path: '/tournaments',
    element: <ActiveTournaments />,
    requiresTournamentAddon: true, // Add this flag
    permissionKey: 'Tournaments - My Tournaments',
  },
  {
    path: '/coach/teams/:id',
    element: <TeamsEdit />,
    requiresTournamentAddon: true, // Add this flag
    permissionKey: 'Tournaments - Tournaments teams',
  },
  {
    path: '/widgets/tournament/:tournamentSlug',
    element: <ProductWizardPage isProduct={false} />,
    requiresTournamentAddon: true, // Add this flag
    permissionKey: 'Tournaments - My Tournaments',
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
];

export const coachPagesConfigs = (rolePermissions) => filterRoutesByPermissions(coachPages, rolePermissions);

const filterRoutesByPermissions = (routes, rolePermissions) => {
  return routes
    .map((route) => {
      if (route.permissionKey) {
        if (!rolePermissions || Object.keys(rolePermissions).length === 0) {
          return null;
        }

        // normalize to array
        const keys = Array.isArray(route.permissionKey)
          ? route.permissionKey
          : [route.permissionKey];
 
        const hasPermission = keys.some((key) => {
          const perms = rolePermissions[key.trim()];
          return perms?.includes('read');
        });
 
        return hasPermission ? route : null;
      }
 
      return route;
    })
    .filter(Boolean);
};